import {CSSProperties} from "react";

// Shared labelled, colour-coded action button for the Compare Branches tool, so
// every migrate/sync/remove control reads the same way:
//   pull   (green)  — bring something from Other into Current (migrate/sync/take)
//   remove (red)    — delete something from Current to match Other
export type ActionVariant = 'pull' | 'remove';

interface ActionButtonProps {
    variant: ActionVariant;
    label: string;
    title?: string;
    disabled?: boolean;
    onClick(): void;
    // fa-* icon class without the "fa-solid" prefix; defaults per variant.
    icon?: string;
    // Compact form for inline per-field rows.
    small?: boolean;
}

const VARIANT_COLOR: Record<ActionVariant, { fg: string; bg: string }> = {
    pull:   {fg: '#7ad17a', bg: 'rgba(102,204,102,0.14)'},
    remove: {fg: '#ff8888', bg: 'rgba(255,120,120,0.14)'},
};

const DEFAULT_ICON: Record<ActionVariant, string> = {
    pull: 'fa-arrow-left',
    remove: 'fa-trash',
};

function ActionButton(props: ActionButtonProps) {
    const c = VARIANT_COLOR[props.variant];
    const icon = props.icon ?? DEFAULT_ICON[props.variant];
    const style: CSSProperties = {
        display: 'inline-flex',
        alignItems: 'center',
        gap: 5,
        padding: props.small ? '1px 6px' : '2px 9px',
        fontSize: props.small ? 11 : 12,
        color: props.disabled ? 'var(--muted-text-color)' : c.fg,
        background: props.disabled ? 'transparent' : c.bg,
        border: `1px solid ${props.disabled ? 'var(--overlay-color)' : c.fg}`,
        borderRadius: 4,
        opacity: props.disabled ? 0.4 : 1,
        cursor: props.disabled ? 'not-allowed' : 'pointer',
        whiteSpace: 'nowrap',
    };
    return (
        <button title={props.title} disabled={props.disabled}
                onClick={props.onClick} style={style}>
            <span className={`fa-solid ${icon}`} style={{fontSize: props.small ? 10 : 11}}/>
            {props.label}
        </button>
    );
}

export default ActionButton;
